import React, { useCallback } from 'react'

import PropTypes from 'prop-types'

import I18n from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'

import { Container, MainText, HeaderText } from './styles'

const SuccessModal = (props) => {
  const {
    id,
    open,
    handleClose,
    message,
    title,
    buttonText,
    onConfirm
  } = props

  const handleClick = useCallback(
    () => {
      handleClose()
      onConfirm()
    },
    [handleClose, onConfirm]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      escape={ false }
      hideHeader
      maxWidth="xs"
    >
      <Container>

        <HeaderText>
          {title}
        </HeaderText>

        {message && (
          <MainText>
            {message}
          </MainText>
        )}

        <Button
          id="ok-success"
          onClick={ handleClick }
          style={ { minWidth: 100, marginTop: 10 } }
          variant="text"
          color="text"
        >
          {buttonText || <I18n>close</I18n>}
        </Button>

      </Container>
    </Modal>
  )
}

SuccessModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  buttonText: PropTypes.string,
  onConfirm: PropTypes.func
}

SuccessModal.defaultProps = {
  message: null,
  title: null,
  buttonText: null,
  onConfirm: () => {}
}

export default SuccessModal
